"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormBuilderLogic = void 0;
const react_1 = require("react");
const schemaExtractor_1 = require("../../../utils/schemaExtractor");
const SessionBuilderContext_1 = require("../../../context/SessionBuilderContext");
const SessionContext_1 = require("../../../context/SessionContext");
const FormSettingsContext_1 = require("../../../context/FormSettingsContext");
const useFormBuilderLogic = () => {
    const { session } = (0, SessionContext_1.useSession)();
    const { generatedCode } = (0, SessionBuilderContext_1.useSessionBuilder)();
    const { setCurrentSchema, setFilteredHtml, setFilteredSchema, selectedForm, originalSchema, extractSchema, } = (0, FormSettingsContext_1.useFormSetting)();
    (0, react_1.useEffect)(() => {
        var _a;
        setCurrentSchema((_a = session === null || session === void 0 ? void 0 : session.schema) !== null && _a !== void 0 ? _a : null);
    }, [session]);
    // Filter schema and HTML after extraction
    (0, react_1.useEffect)(() => {
        if (originalSchema && generatedCode) {
            console.log(originalSchema, "inside");
            const { filteredSchema, updatedHtml } = (0, schemaExtractor_1.filterSchemaAndHtmlByQuestions)(originalSchema, generatedCode, selectedForm ? selectedForm.questions : []);
            setFilteredSchema(filteredSchema);
            setFilteredHtml(updatedHtml);
        }
    }, [originalSchema, generatedCode, selectedForm]);
    (0, react_1.useEffect)(() => {
        console.log("useEffect extractSchema: START");
        if (generatedCode && generatedCode.trim()) {
            console.log("useEffect extractSchema: IN IF");
            extractSchema(generatedCode, {
                name: "Generated Form",
                description: "Form generated from AI prompt",
                prompt: "AI generated form",
            });
        }
    }, [generatedCode]);
};
exports.useFormBuilderLogic = useFormBuilderLogic;
